import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLazyGetAllExternalUsersQuery } from '../store/externalUser/externalUser'
import { useAppSelector } from '../store/hooks'
import { selectAccountId, selectSafeAuthenticatedUser } from '../store/auth/authSlice'
import { IntegrationServiceId } from './integrations'

type IframeMessage = { type: string; [key: string]: unknown }

export const useIframeMessageHandler = () => {
  const accountId = useAppSelector(selectAccountId)
  const currentUser = useAppSelector(selectSafeAuthenticatedUser)

  const navigate = useNavigate()
  const [getAllExternalUsers] = useLazyGetAllExternalUsersQuery()

  useEffect(() => {
    window.parent.postMessage({ type: 'ZOCKS_APP_LOADED' }, '*')
  }, [])

  useEffect(() => {
    const handleMessage = async (event: MessageEvent<IframeMessage>) => {
      const { data } = event
      if (!data || typeof data !== 'object') {
        return
      }

      if (data.type === 'IC_REDIRECT_TO_CONTACT' && data.contactId) {
        const externalUsers = await getAllExternalUsers({ accountId, serviceId: IntegrationServiceId.INVESTCLOUD, externalId: data.contactId as string })
        if (!externalUsers?.data || !externalUsers.data.data.length || externalUsers.data.data.length > 1) {
          navigate(`/workspace/upcoming`)
          return
        }
        const externalUserId = externalUsers.data.data[0].id
        navigate(`/workspace/upcoming?contactId=${externalUserId}&userId=${currentUser.id}`)
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [accountId, currentUser, getAllExternalUsers, navigate])
}
